import { render, staticRenderFns } from "./legendSalinity.vue?vue&type=template&id=33ed73a5&scoped=true"
import script from "./legendSalinity.vue?vue&type=script&lang=ts"
export * from "./legendSalinity.vue?vue&type=script&lang=ts"
import style0 from "./legendSalinity.vue?vue&type=style&index=0&id=33ed73a5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ed73a5",
  null
  
)

export default component.exports